document.addEventListener('DOMContentLoaded', () => {

    const reviewsSwiper = new Swiper('.reviews-swiper', {
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		autoplay: {
			delay: 7000,
		},
		speed: 800,
		loop: true,
        pagination: {
			el: ".reviews-pagination",
			clickable: true,
        },
		breakpoints: {
			600: {
				navigation: {
					nextEl: '.reviews-next',
					prevEl: '.reviews-prev',
				}
			}
		}
	});

	const heroSwiper = new Swiper('.hero-swiper', {
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		loop: true,
		autoplay: {
			delay: 4000,
		},
		speed: 800,
        pagination: {
			el: ".hero-pagination",
			clickable: true,
        }
	});

	const sliderSwiper = new Swiper('.slider-swiper', {
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		loop: true,
		navigation: {
			nextEl: '.slider-next',
			prevEl: '.slider-prev',
		}
	});

	const roomsSwiper = new Swiper('.rooms-swiper', {
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		loop: true,
		navigation: {
			nextEl: '.rooms-next',
			prevEl: '.rooms-prev',
		}
	});

});